import { render, staticRenderFns } from "./LoginUser.vue?vue&type=template&id=2bbb2716&scoped=true"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"
import style0 from "./LoginUser.vue?vue&type=style&index=0&id=2bbb2716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb2716",
  null
  
)

export default component.exports